<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h1>Areas</h1>
        </b-col>
      </b-row>
      <!-- <b-row class="text-left my-2">
        <b-col>
          <b-button variant="success" @click="$bvModal.show('modal-newProvider')" size="sm mr-3">Crear Tipo
            +</b-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small  :filter="search" striped hover :items="supply_list" :fields="comprasLabels"  responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="statusBadge(data.item.status).variant">{{ statusBadge(data.item.status).text
                }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="success"
                @click="getProvider(data.item.id); $bvModal.show('modal-newProvider')" class="mr-1">
                +Info
              </b-button>
              <b-button size="sm" variant="primary"
                @click="openAutoProductsModal(data.item)" class="mr-1">
                Auto Productos
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-newProvider" @close="emptyNewItem" :hide-footer="true" size="xl"
      :title="(newItem.id > 0 ? 'Editar' : 'Agregar') + ' Area'">
      <b-row>
        <b-col lg="6" cols="12">
          <b-form-group label="Descripcion" >
            <b-form-input v-model="newItem.description" placeholder="Nombre" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6" cols="12">
          <b-form-group label="Entrada/Salida" >
            <b-form-select v-model="newItem.in_out">
              <b-form-select-option :value="1">Entrada</b-form-select-option>
              <b-form-select-option :value="2">Salida</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="6" cols="12">
          <b-form-group label="Status">
            <b-form-checkbox v-model="newItem.sts" :value="true"
              :unchecked-value="false">
              Activo/Inactivo
            </b-form-checkbox> </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <p>Puedes Habilitar hasta tres referencias:</p>
        </b-col>
      </b-row>
     <b-card>
      <b-row>
        <b-col cols="12">
          <p>Referencia1:</p>
        </b-col>
        <b-col lg="12" cols="12">
          <b-form-group>
            <b-form-checkbox v-model="newItem.ref1_available" :value="true"
              :unchecked-value="false">
              Activo/Inactivo
            </b-form-checkbox> </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref1_available" lg="6" cols="12">
          <b-form-group label="Texto">
            <b-form-input v-model="newItem.ref1_text" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref1_available" lg="6" cols="12">
          <b-form-group label="Tipo de control" >
            <b-form-select v-model="newItem.ref1_type">
              <b-form-select-option value="text">Texto</b-form-select-option>
              <b-form-select-option value="number">Numero</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
     </b-card>
     <b-card>
      <b-row>
        <b-col cols="12">
          <p>Referencia 2:</p>
        </b-col>
        <b-col lg="12" cols="12">
          <b-form-group >
            <b-form-checkbox v-model="newItem.ref2_available" :value="true"
              :unchecked-value="false">
              Activo/Inactivo
            </b-form-checkbox> </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref2_available" lg="6" cols="12">
          <b-form-group label="Texto">
            <b-form-input v-model="newItem.ref2_text" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref2_available" lg="6" cols="12">
          <b-form-group label="Tipo de control" >
            <b-form-select v-model="newItem.ref2_type">
              <b-form-select-option value="text">Texto</b-form-select-option>
              <b-form-select-option value="number">Numero</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
     </b-card>
     <b-card>
      <b-row>
        <b-col cols="12">
          <p>Referencia 3:</p>
        </b-col>
        <b-col lg="12" cols="12">
          <b-form-group>
            <b-form-checkbox v-model="newItem.ref3_available" :value="true"
              :unchecked-value="false">
              Activo/Inactivo
            </b-form-checkbox> </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref3_available" lg="6" cols="12">
          <b-form-group label="Texto">
            <b-form-input v-model="newItem.ref3_text" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="newItem.ref3_available" lg="6" cols="12">
          <b-form-group label="Tipo de control" >
            <b-form-select v-model="newItem.ref3_type">
              <b-form-select-option value="text">Texto</b-form-select-option>
              <b-form-select-option value="number">Numero</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
     </b-card>
      <b-row>
        <b-col class="my-3">
          <b-button class="mr-3" @click="createNewItem" variant="success">Guardar</b-button>
          <b-button class="mr-3" @click="$bvModal.hide('modal-newProvider'); emptyNewItem();"
            variant="danger">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Auto Products Modal -->
    <b-modal id="modal-autoProducts" :hide-footer="true" size="xl"
      :title="'Auto Productos - ' + selectedArea.name">
      <b-row>
        <b-col cols="12">
          <h5>Productos que se agregan automáticamente al crear una orden en esta área</h5>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="success" size="sm" @click="showAddProductForm = true" v-if="!showAddProductForm">
            + Agregar Producto
          </b-button>
        </b-col>
      </b-row>

      <!-- Add Product Form -->
      <b-row v-if="showAddProductForm" class="mt-3">
        <b-col cols="12">
          <b-card bg-variant="light">
            <b-row>
              <b-col lg="6" cols="12">
                <b-form-group label="Producto">
                  <b-form-select v-model="newAutoProduct.product_id" :options="productOptions">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Selecciona un producto --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="3" cols="12">
                <b-form-group label="Cantidad">
                  <b-form-input v-model.number="newAutoProduct.quantity" type="number" min="1"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3" cols="12">
                <b-form-group label="Estado">
                  <b-form-select v-model="newAutoProduct.status">
                    <b-form-select-option :value="true">Activo</b-form-select-option>
                    <b-form-select-option :value="false">Inactivo</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-button variant="success" size="sm" @click="createAutoProduct" class="mr-2">Guardar</b-button>
                <b-button variant="secondary" size="sm" @click="cancelAddProduct">Cancelar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- Auto Products List -->
      <b-row class="mt-3">
        <b-col cols="12">
          <b-table small striped hover :items="autoProducts" :fields="autoProductsLabels" responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="data.item.status ? 'success' : 'danger'">
                {{ data.item.status ? 'Activo' : 'Inactivo' }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button size="sm" variant="danger" @click="deleteAutoProduct(data.item.id)">
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="secondary" @click="closeAutoProductsModal">Cerrar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import autoProductsService from "../services/autoProductsService";


export default {
  name: "RestaurantAreas",
  components: {
    Nav
  },

  data() {
    return {
      newItem: {
        description: '',
        sts:false,
        in_out:null,

        ref1_available:false,
        ref1_text:"",
        ref1_type:"",

        ref2_available:false,
        ref2_text:"",
        ref2_type:"",

        ref3_available:false,
        ref3_text:"",
        ref3_type:"",

      },
      search: "",
      supply_list: [],
      comprasLabels: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "status", label: "Status" },
        { key: "buttons", label: "" }
      ],
      // Auto Products data
      selectedArea: {},
      autoProducts: [],
      showAddProductForm: false,
      newAutoProduct: {
        restaurant_area_id: null,
        product_id: null,
        quantity: 1,
        status: 'active'
      },
      productOptions: [],
      autoProductsLabels: [
        { key: "id", label: "ID" },
        { key: "product_id", label: "ID Producto" },
        { key: "quantity", label: "Cantidad" },
        { key: "status", label: "Estado" },
        { key: "actions", label: "Acciones" }
      ]
    };
  },

  computed: {

  },
  watch: {},
  mounted() {
    this.getLists()
  },
  created() {

  },
  methods: {
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "ACTIVE":
          rtn.variant = "success"
          rtn.text = "Activo"
          break;
        case "INACTIVE":
          rtn.variant = "danger"
          rtn.text = "Inactivo"
          break;
      }
      return rtn
    },
    createNewItem() {
      let that = this
      let elm = this.newItem
      if (!this.newItem.is_internal){
        this.newItem.sucursal_id=null
      }
      if(this.newItem.id>0){
        axios.put("/restaurant/area/"+this.newItem.id, elm)
        .then(function (res) {
          if (res.data.id > 0) {
            that.getLists()
            that.emptyNewItem()
            that.$bvModal.hide("modal-newProvider")
          }
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
      }else{
        axios.post("/restaurant/area", elm)
        .then(function (res) {
          if (res.data.id > 0) {
            that.getLists()
            that.emptyNewItem()
            that.$bvModal.hide("modal-newProvider")
          }
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
      }
      

    },
    emptyNewItem() {
      this.newItem = {
        name: '',
        description: ''
      }
    },
    getProvider(id) {
      let that = this
      axios.get("/restaurant/area/" + id)
        .then(function (res) {
          that.newItem = res.data
        }).catch(function (err) {
          console.error(err)
        })
    },
    getLists() {
      let that = this
      axios.get("/restaurant/areas")
        .then(function (res) {
          that.supply_list = res.data
        }).catch(function (err) {
          console.error(err)
        })
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvModal.msgBoxOk(text, {
        title: title,
        okVariant: variant,
        centered: true
      })
    },

    // Auto Products Methods
    async openAutoProductsModal(area) {
      this.selectedArea = area;
      this.newAutoProduct.restaurant_area_id = area.id;
      await this.loadAutoProducts(area.id);
      await this.loadProducts();
      this.$bvModal.show('modal-autoProducts');
    },

    async loadAutoProducts(areaId) {
      try {
        const response = await autoProductsService.getAutoProductsByAreaId(areaId);
        this.autoProducts = response.data || [];
      } catch (err) {
        console.error('Error loading auto products:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar los productos automáticos');
      }
    },

    async loadProducts() {
      try {
        const response = await axios.get('/productswithoutprices');
        this.productOptions = (response.data || [])
          .filter(p => p.status )
          .map(p => ({
            value: p.id,
            text: `${p.ndescription || p.clave || 'Sin nombre'} (ID: ${p.id})`
          }));
      } catch (err) {
        console.error('Error loading products:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar los productos');
      }
    },

    async createAutoProduct() {
      if (!this.newAutoProduct.product_id) {
        this.makeToast('warning', 'Advertencia', 'Por favor selecciona un producto');
        return;
      }

      try {
        await autoProductsService.createAutoProduct(this.newAutoProduct);
        this.makeToast('success', 'Éxito', 'Producto automático agregado correctamente');
        await this.loadAutoProducts(this.selectedArea.id);
        this.cancelAddProduct();
      } catch (err) {
        console.error('Error creating auto product:', err);
        this.makeToast('danger', 'Error', err.response?.data || 'No se pudo agregar el producto automático');
      }
    },

    async deleteAutoProduct(autoProductId) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        '¿Estás seguro de eliminar este producto automático?',
        {
          title: 'Confirmar eliminación',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          centered: true
        }
      );

      if (confirmed) {
        try {
          await autoProductsService.deleteAutoProduct(autoProductId);
          this.makeToast('success', 'Éxito', 'Producto automático eliminado correctamente');
          await this.loadAutoProducts(this.selectedArea.id);
        } catch (err) {
          console.error('Error deleting auto product:', err);
          this.makeToast('danger', 'Error', 'No se pudo eliminar el producto automático');
        }
      }
    },

    cancelAddProduct() {
      this.showAddProductForm = false;
      this.newAutoProduct = {
        restaurant_area_id: this.selectedArea.id,
        product_id: null,
        quantity: 1,
        status: 'active'
      };
    },

    closeAutoProductsModal() {
      this.$bvModal.hide('modal-autoProducts');
      this.selectedArea = {};
      this.autoProducts = [];
      this.showAddProductForm = false;
    }
  },
};
</script>
